// components/animations/AnimatedBackground.jsx
import React from 'react';
import { Box, keyframes } from '@mui/material';

const floatAnimation = keyframes`
  0% { transform: translateY(0) translateX(0) scale(1); }
  25% { transform: translateY(-100px) translateX(50px) scale(1.2); }
  50% { transform: translateY(-50px) translateX(100px) scale(0.8); }
  75% { transform: translateY(50px) translateX(50px) scale(1.1); }
  100% { transform: translateY(0) translateX(0) scale(1); }
`;

const AnimatedBackground = ({ count = 15 }) => {
  // Generate random background elements
  const elements = Array.from({ length: count }, (_, i) => ({
    id: i,
    size: 20 + Math.random() * 50,
    left: Math.random() * 100,
    top: Math.random() * 100,
    animationDuration: 15 + Math.random() * 10,
    animationDelay: Math.random() * 5,
    opacity: 0.1 + Math.random() * 0.2,
  }));
  
  return (
    <Box
      sx={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        zIndex: 0,
      }}
    >
      {elements.map((element) => (
        <Box
          key={element.id}
          sx={{
            position: 'absolute',
            width: `${element.size}px`,
            height: `${element.size}px`,
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(255,255,255,0) 30%, rgba(0,123,255,0.3) 100%)',
            left: `${element.left}%`,
            top: `${element.top}%`,
            opacity: element.opacity,
            animation: `${floatAnimation} ${element.animationDuration}s linear infinite`,
            animationDelay: `${element.animationDelay}s`,
          }}
        />
      ))}
    </Box>
  );
};

export default AnimatedBackground;